if (typeof VideoBackgroundElement !== 'function') {
  class VideoBackgroundElement extends HTMLElement {
    constructor() {
      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      this.fallbackLoaded = false;

      const video = this.querySelector('video');

      const markLoaded = () => {
        if (!this.classList.contains('loaded')) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }

        const fallback = this.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);

        if (fallback && this.fallbackLoaded) {
          fallback.innerHTML = '';
          this.fallbackLoaded = false;
        }
      };

      video.addEventListener('error', () => {
        this.switchFallback();
      });

      video.addEventListener('loadeddata', markLoaded);
      video.addEventListener('canplay', markLoaded);
      video.addEventListener('playing', markLoaded);

      const loadVideo = () => {
        video.querySelectorAll('source').forEach(source => {
          if (!source.src && source.dataset.src) {
            source.src = source.dataset.src;
          }
        });

        video.load();

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            // Ignore play promise failures. The video may still load/play later.
          });
        }
      };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        if (!this.classList.contains('loaded')) {
          loadVideo();
        }

        observer.unobserve(entries[0].target);
      };

      if (
        this.getBoundingClientRect().y < window.innerHeight ||
        this.parentNode.getBoundingClientRect().y < window.innerHeight
      ) {
        loadVideo();
      } else {
        const observer = new IntersectionObserver(handleIntersection, {
          rootMargin: `0px 0px 400px 0px`
        });

        observer.observe(this);
        observer.observe(this.parentElement);
      }
    }

    switchFallback() {
      if (this.fallbackLoaded || this.classList.contains('loaded')) return;

      const fallback = this.querySelector(
        `[data-video-background-fallback][data-id="${this.dataset.id}"]`
      );

      if (fallback && fallback.querySelector('template')) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));

        const img = fallback.querySelector('img');

        if (img && img.getAttribute('srcset')) {
          img.setAttribute('srcset', img.getAttribute('srcset'));
        }

        this.fallbackLoaded = true;
      }

      this.dispatchEvent(this._eventFail);
    }
  }

  if (typeof customElements.get('video-background-element') === 'undefined') {
    customElements.define('video-background-element', VideoBackgroundElement);
  }
}